import TemplatesView from './views/templates/templates.view.vue';

export const BOOKSTORE_ROUTES = {
  TEMPLATES: {
    NAME: 'private.bookstore.templates',
    PATH: 'templates'
  }
};

export const bookstoreRoutes = [
  { 
    name: BOOKSTORE_ROUTES.TEMPLATES.NAME,
    path: BOOKSTORE_ROUTES.TEMPLATES.PATH,
    component: TemplatesView
  },
  {
    path: '/',
    redirect: { 
      name: BOOKSTORE_ROUTES.TEMPLATES.NAME 
    }
  }
];